// extracted by mini-css-extract-plugin
export var base = "formText-module--base--e7d47";
export var large = "formText-module--large--ed3b6 formText-module--base--e7d47";
export var regular = "formText-module--regular--5f9d5 formText-module--base--e7d47";
export var small = "formText-module--small--01bb0 formText-module--base--e7d47";